import HomeIcon from '@mui/icons-material/Home';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Success } from '../../../shared/lib/assets';
import palette from '../../../shared/lib/theme/palette';
import { StepperContentWrapper } from '../../../shared/lib/theme/styleConstants';
import { ONBOARDING_FINISH_STRINGS } from '../../../shared/lib/constants';
import { withTrademark } from '../../../shared/lib/common/Tokenizer';
import { LINKS } from '../app/constants';
import { useMobileView } from '../app/hooks/useMobileView';

interface FinishStepperProps {
  isChangePlan?: boolean;
}

export const FinishStepper = ({ isChangePlan = false }: FinishStepperProps) => {
  const mediumViewport = useMobileView();
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigate(LINKS.DASHBOARD_LINK);
  };

  const { blackOne, blackTwo } = palette;

  const title = isChangePlan ? ONBOARDING_FINISH_STRINGS.CHANGE_TITLE : ONBOARDING_FINISH_STRINGS.TITLE;
  const body = isChangePlan ? ONBOARDING_FINISH_STRINGS.CHANGE_BODY : ONBOARDING_FINISH_STRINGS.BODY;

  return (
    <Box sx={StepperContentWrapper}>
      <Box textAlign="center" width={mediumViewport ? '100%' : '500px'} paddingX={mediumViewport ? '20px' : '0'}>
        <Box mb="40px">{Success()}</Box>

        <Typography variant="h3" mb={2} sx={{ color: blackOne }}>
          {title}
        </Typography>

        {!isChangePlan && (
          <Typography variant="subtitle2" sx={{ color: blackTwo }}>
            {withTrademark(ONBOARDING_FINISH_STRINGS.WELCOME)}
          </Typography>
        )}

        <Typography variant="subtitle2" textAlign="center" sx={{ color: blackTwo }}>
          {withTrademark(body)}
        </Typography>

        <Button startIcon={<HomeIcon />} sx={{ marginTop: '24px' }} fullWidth variant="contained" color="primary" onClick={goToDashboard}>
          {ONBOARDING_FINISH_STRINGS.BUTTON}
        </Button>
      </Box>
    </Box>
  );
};
